import Dispatcher from '../dispatcher';
import shippingFeesConstant from '../constants/shipping_fees_contsants';

export const receiveShippingData = response => {
  Dispatcher.handleShippingAction({
    type: shippingFeesConstant.RECEIVE_SHIPPING_DATA,
    payload: response,
  });
}

export const receiveShippingFail = response => {
  Dispatcher.handleShippingAction({
    type: shippingFeesConstant.RECEIVE_SHIPPING_FAIL,
    payload: response,
  });
}

export const receiveAdShippingData = response => {
  Dispatcher.handleShippingAction({
    type: shippingFeesConstant.RECEIVE_AD_SHIPPING_DATA,
    payload: response,
  });
}

export const receiveAdShippingFail = response => {
  Dispatcher.handleShippingAction({
    type: shippingFeesConstant.RECEIVE_AD_SHIPPING_FAIL,
    payload: response,
  });
}